import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { CurrentYearMonth, PagingOptions, SortType } from '@/coreInfrastructureModule/axios/generated/trashBinManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { TrashBinAdapter } from '../adapters/TrashBinAdapter';
import { IAggregateBusiness } from '../domains/entities/aggregateBusiness';

/**
 * GetTrashBinAggregateBusinessUseCase
 */
export class GetTrashBinAggregateBusinessUseCase {
  /**
   * 集計情報取得
   * @param repository - ゴミ箱のリポジトリ
   * @param sortType - ソートタイプ
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param sortTarget - ソート対象
   * @param filterItems - フィルターの一覧
   */
  static async execute(
    repository: ITrashBinRepository,
    sortType: SortType,
    limit: number,
    offset: number,
    sortTarget: string | undefined,
    filterItems: FilterContentItem[]
  ): Promise<INetworkResult<[Array<IAggregateBusiness>, IPagingOptions], IError>> {
    const filterItem = FilterService.convertCustomerForecastFilterItems(filterItems);
    const currentDate = new Date();
    const currentYearMonth: CurrentYearMonth = {
      currentYear: currentDate.getFullYear(),
      currentMonth: currentDate.getMonth() + 1, // Date型のmonthは0~11なので、+1している
    };
    const networkResult = await repository.getTrashBinAggregateBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: [
              TrashBinAdapter.adaptAggregateBusiness(networkResult.status.data.result),
              networkResult.status.data.result.pagingOptions as PagingOptions,
            ],
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
